var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuspath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.723,
    height: 15.099,
    viewBox: "0 0 12.723 15.099",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M301.308,732.436a18.2,18.2,0,0,1,9.537,0,2.45,2.45,0,0,1,1.669,2.543v7.55a2.716,2.716,0,0,1-2.781,2.781l1.192,1.192v.4h-9.536v-.4l1.192-1.192a2.716,2.716,0,0,1-2.781-2.781v-7.55A2.394,2.394,0,0,1,301.308,732.436Zm3.974,6.517v-3.974h-3.974v3.974Zm-3.656,4.451a1.361,1.361,0,1,0-.318-.874A1.086,1.086,0,0,0,301.626,743.4Zm9.219-4.451v-3.974h-3.974v3.974Zm-2.066,4.451a1.361,1.361,0,1,0-.318-.874A1.086,1.086,0,0,0,308.778,743.4Z",
    transform: "translate(-299.791 -731.8)",
    fill: "#fd5634"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuspath);
export default __webpack_public_path__ + "static/media/buspath.15ca488d0ac406a10dd7f7e8636fa871.svg";
export { ForwardRef as ReactComponent };